var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07812 5.92432C5.07812 4.38692 6.34092 3.14062 7.89865 3.14062H12.0012C12.426 3.14062 12.7704 3.48052 12.7704 3.89981C12.7704 4.3191 12.426 4.659 12.0012 4.659H7.89865C7.19059 4.659 6.6166 5.2255 6.6166 5.92432V6.93657C6.6166 7.35586 6.27219 7.69576 5.84736 7.69576C5.42252 7.69576 5.07812 7.35586 5.07812 6.93657V5.92432ZM5.84736 16.2999C6.27219 16.2999 6.6166 16.6398 6.6166 17.0591V18.0713C6.6166 18.7701 7.19059 19.3366 7.89865 19.3366H12.0012C12.426 19.3366 12.7704 19.6766 12.7704 20.0958C12.7704 20.5151 12.426 20.855 12.0012 20.855H7.89865C6.34092 20.855 5.07812 19.6087 5.07812 18.0713V17.0591C5.07812 16.6398 5.42252 16.2999 5.84736 16.2999Z",
    fill: "#B2B3B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7689 4.78618C12.7689 3.90491 13.6589 3.29355 14.4963 3.59962L19.6245 5.47416C20.1274 5.658 20.4612 6.13139 20.4612 6.66071V17.3393C20.4612 17.8686 20.1274 18.342 19.6245 18.5258L14.4963 20.4004C13.6589 20.7065 12.7689 20.0951 12.7689 19.2138V4.78618ZM15.0306 2.17576C13.1884 1.5024 11.2305 2.84738 11.2305 4.78618V19.2138C11.2305 21.1526 13.1884 22.4976 15.0306 21.8242L20.1588 19.9497C21.2653 19.5452 21.9997 18.5038 21.9997 17.3393V6.66071C21.9997 5.4962 21.2653 4.45475 20.1588 4.0503L15.0306 2.17576Z",
    fill: "#B2B3B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32787 9.44112C6.62827 9.14463 7.11532 9.14463 7.41572 9.44112L9.46701 11.4656C9.76741 11.7621 9.76741 12.2427 9.46701 12.5392L7.41572 14.5637C7.11532 14.8602 6.62827 14.8602 6.32787 14.5637C6.02746 14.2673 6.02746 13.7866 6.32787 13.4901L7.06599 12.7616H2.76923C2.3444 12.7616 2 12.4217 2 12.0024C2 11.5831 2.3444 11.2432 2.76923 11.2432H7.06599L6.32787 10.5147C6.02746 10.2182 6.02746 9.7376 6.32787 9.44112Z",
    fill: "#B2B3B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/LogOut.85aae7850733608aa9542347cfedacf8.svg";
export { ForwardRef as ReactComponent };